import React, { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import ReactionWidget from '../../collection-templates/reaction-widget';
import isEmpty from 'lodash/isEmpty';

const BudgetReactionsFullWidget = (props) => {
  const queryClient = new QueryClient;
  const [collectionData, setCollectionData] = useState({});
  const [darkMode, setDarkMode] = useState(false);
  const [lightMode, setLightMode] = useState(false);
  const [client, setClient] = useState('');

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const dm = urlParams.get('dm');
    const disabledm = urlParams.get('disabledm');
    const client = urlParams.get('client');

    if (dm == 1) {
      setDarkMode(true);
      setLightMode(false);
    } else if (disabledm == 1) {
      setDarkMode(false);
      setLightMode(true);
    } else {
      setDarkMode(false);
      setLightMode(false);
    }

    if (!!client) {
      setClient(client);
    }

    if (disabledm === "1") {
      const body = document.getElementsByTagName('body')[0];
      body.style.backgroundColor = "#FFFFFF";
    } else if (dm === "1" || (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
      const body = document.getElementsByTagName('body')[0];
      body.style.backgroundColor = "#2B2B2B";
    }

    const getCollectionData = async () => {
      if (isEmpty(collectionData)) {
        try {
          const response = await fetch('https://www.ndtvprofit.com/api/v1/collections/budget-wishlist').then(res => res.json());
          setCollectionData(response);
        } catch (e) {
          console.log('Error in api');
        }
      }
    }

    getCollectionData();
  }, []);
  return (
    <QueryClientProvider client={queryClient}>
      {!isEmpty(collectionData) && (
        <ReactionWidget
          widget={true}
          collection={collectionData}
          target="_parent"
          darkMode={darkMode}
          lightMode={lightMode}
          client={client}
          {...props} />
      )}
    </QueryClientProvider>
  );
};

export { BudgetReactionsFullWidget };
